import React from "react";

import { Card, CardContent, CardHeader, Grid } from "@mui/material";
import Classrooms from "./classroom/ClassroomDashboard";

const TeacherDashboard: React.FC = () => {
  return (
    <Grid container spacing={3} style={{ marginBottom: "2rem" }}>
      <Grid item xs={12}>
        <Classrooms></Classrooms>
      </Grid>
    </Grid>
  );
};

export default TeacherDashboard;
